/**
 * Cart Cross-Sells - Single Horizontal Slide
 * Shows one product at a time with prev/next navigation
 */

(function() {
  'use strict';

  const CartCrossSells = {
    selectors: {
      wrapper: '.cart-cross-sells-wrapper',
      slider: '.cart-cross-sells-slider',
      prevBtn: '.cart-cross-sells-prev',
      nextBtn: '.cart-cross-sells-next',
      addBtn: '.cart-cross-sell-add-btn',
      items: '.cart-cross-sell-item'
    },

    currentIndex: 0,
    totalItems: 0,

    init() {
      this.wrapper = document.querySelector(this.selectors.wrapper);
      
      if (!this.wrapper) return;

      this.slider = this.wrapper.querySelector(this.selectors.slider);
      this.prevBtn = this.wrapper.querySelector(this.selectors.prevBtn);
      this.nextBtn = this.wrapper.querySelector(this.selectors.nextBtn);
      this.items = this.wrapper.querySelectorAll(this.selectors.items);
      this.totalItems = this.items.length;
      
      if (this.totalItems === 0) return;

      this.bindEvents();
      this.updateNavButtons();
    },

    bindEvents() {
      // Navigation buttons
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
      }
      
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
      }

      // Add to cart buttons
      const addButtons = this.wrapper.querySelectorAll(this.selectors.addBtn);
      addButtons.forEach(btn => {
        btn.addEventListener('click', (e) => this.handleAddToCart(e));
      });

      // Keyboard navigation
      document.addEventListener('keydown', (e) => {
        if (!this.wrapper.contains(document.activeElement)) return;
        
        if (e.key === 'ArrowLeft') {
          this.goToSlide(this.currentIndex - 1);
        } else if (e.key === 'ArrowRight') {
          this.goToSlide(this.currentIndex + 1);
        }
      });
    },

    goToSlide(index) {
      // Clamp index to valid range
      if (index < 0) index = 0;
      if (index >= this.totalItems) index = this.totalItems - 1;
      
      this.currentIndex = index;
      
      // Scroll to the item
      const scrollAmount = this.slider.clientWidth * index;
      this.slider.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });

      this.updateNavButtons();
    },

    updateNavButtons() {
      if (!this.prevBtn || !this.nextBtn) return;

      // Disable prev button if at start
      this.prevBtn.disabled = this.currentIndex === 0;
      
      // Disable next button if at end
      this.nextBtn.disabled = this.currentIndex === this.totalItems - 1;
    },

    async handleAddToCart(e) {
      const button = e.currentTarget;
      const variantId = button.dataset.variantId;
      const productTitle = button.dataset.productTitle;

      if (!variantId || button.disabled || button.classList.contains('loading')) {
        return;
      }

      // Set loading state
      button.classList.add('loading');
      button.disabled = true;

      try {
        // Add to cart via Shopify AJAX API
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Trigger cart update event (Symmetry theme listens for this)
        document.dispatchEvent(
          new CustomEvent('on:cart:change', { 
            bubbles: true, 
            cancelable: false 
          })
        );

        // Show success feedback
        this.showSuccessFeedback(button, productTitle);

      } catch (error) {
        console.error('Error adding to cart:', error);
        this.showErrorFeedback(button);
      } finally {
        // Remove loading state
        setTimeout(() => {
          button.classList.remove('loading');
          button.disabled = false;
        }, 1000);
      }
    },

    showSuccessFeedback(button, productTitle) {
      const btnText = button.querySelector('.btn-text');
      const originalText = btnText.textContent;
      btnText.textContent = 'ADDED!';
      button.style.background = '#22c55e';
      
      setTimeout(() => {
        btnText.textContent = originalText;
        button.style.background = '';
      }, 2000);
    },

    showErrorFeedback(button) {
      const btnText = button.querySelector('.btn-text');
      const originalText = btnText.textContent;
      btnText.textContent = 'ERROR';
      button.style.background = '#c53131';
      
      setTimeout(() => {
        btnText.textContent = originalText;
        button.style.background = '';
      }, 2000);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CartCrossSells.init());
  } else {
    CartCrossSells.init();
  }

  // Re-initialize when cart drawer opens
  document.addEventListener('cart:drawer:open', () => {
    setTimeout(() => CartCrossSells.init(), 100);
  });

})();